<template>
    <div id="step_component_wrapper">
        <div class="slot-content">
            <h4>{{'Matricola: ' + machineID }}</h4>
            <h4>{{'Modello: ' + modelID }}</h4>
        </div>
        <div class="slot-button">
            <button v-if="!backTo1Allowed" class="btn btn-danger" @click="$root.logout()">Logout</button>
            <button v-else class="btn btn-danger" @click="$emit('backward')">{{$Jed.firstUpperTranslate('back', null)}}</button>

            <popover-alert effect="fade" placement="top" 
            :title="$Jed.firstUpperTranslate('are you sure?', null)"
            :content="$Jed.firstUpperTranslate('you are being redirected to the %1$s menu', null, {key: 'product identify'})" 
            :ok="backward" 
            :popoverStyle="{ right:'10px', 'max-width': '200px', width: '100%', 'font-size': 'small', height: 'max-content', bottom: '60px'}" 
            :arrowStyle="{left:'75%'}" :textStyle="{color: '#222'}" classes="autoleft autotop" >
                <button class="btn btn-danger" style="margin: 0px 5px">{{$Jed.firstUpperTranslate('back', null)}}</button>
            </popover-alert>
            
        </div>
    </div>
</template>
<script>
import PopoverAlert from '../../dynamic/popoverWrapper/Popover.vue'
    export default {
        props: {
            machineID: String,
            modelID: String,
            backTo1Allowed: {
               type: Boolean,
               default: false
            }
        },
        components: {
            PopoverAlert
        },
        methods: {
            backward: function(){
                this.$emit("forward", {step: 2})
            }
        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/loader/steps/RegistrazioneProdotto.vue?6caebbba